import {
    HangupAction,
    JITSI_HANGUP,
    JITSI_MEET,
    JITSI_MEET_ROOM_DETAILS,
    JITSI_REQUEST_AUTO_JOIN,
    JITSI_TOGGLE_CHAT,
    JITSI_VIDEO_CONFERENCE_JOINED,
    MeetAction,
    MeetRoomDetailsAction,
    RequestAutoJoinAction,
    ToggleChatAction,
    VideoConferenceJoinedAction,
} from './types'

export const jitsiHangup = (): HangupAction => ({type: JITSI_HANGUP})
export const jitsiMeet = (channel_id: string): MeetAction => ({
    channel_id,
    type: JITSI_MEET,
})
export const jitsiMeetRoomDetails = (roomDetails: Pick<MeetRoomDetailsAction, 'jitsi_room'|'jitsi_token'>): MeetRoomDetailsAction => ({
    ...roomDetails,
    type: JITSI_MEET_ROOM_DETAILS,
})
export const jitsiToggleChat = (): ToggleChatAction => ({type: JITSI_TOGGLE_CHAT})
export const jitsiVideoConferenceJoined = (joined: boolean): VideoConferenceJoinedAction => ({
    joined,
    type: JITSI_VIDEO_CONFERENCE_JOINED,
})

export const jitsiRequestAutoJoin = (channel_id: string): RequestAutoJoinAction => ({
    channel_id,
    type: JITSI_REQUEST_AUTO_JOIN,
})
